import React, { Component } from "react"
import { getCustomColors } from "../utils/js/utils"
// eslint-disable-line no-unused-vars

import "./_badge.scss"

class Badge extends Component {
  static defaultProps = {
    modifier: "",
    content: "<span>Lorem</span><span>Ipsum</span><strong>Dolor</strong>",
    backgroundColor: "",
    textColor: "",
  }

  render() {
    const style = getCustomColors(this.props)

    return (
      <div className={`badge ${this.props.modifier}`} style={style}>
        <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
      </div>
    )
  }
}

export default Badge
